import React, { Component } from 'react';

import './css/OpenQuestion.css';
import StringUtils from "../../utils/StringUtils";

class OpenQuestion extends Component {
    state = {
        answer: ''
    };

    setScore = (event) => {
        let score = Number.parseInt(event.target.value);
        if (score < 0) score = 0;
        if (score > this.props.points) score = Number.parseInt(this.props.points);
        this.props.setScore(this.props.id, score);
    };

    render() {
        return (
            <div className="task-block open-question-check">
                <div className="question-number">Pytanie {this.props.number} (<input type="number" className="score-picker" value={this.props.score} min={0} max={this.props.points} onChange={this.setScore} /> / {this.props.points})</div>
                <div className="question">{StringUtils.parse(this.props.question)}</div>
                <div className="answer">
                    {this.props.answer}
                </div>
            </div>
        );
    }
}

export default OpenQuestion;